import { render, staticRenderFns } from "./speedTable.vue?vue&type=template&id=4beb3e15&scoped=true"
import script from "./speedTable.vue?vue&type=script&lang=js"
export * from "./speedTable.vue?vue&type=script&lang=js"
import style0 from "./speedTable.vue?vue&type=style&index=0&id=4beb3e15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb3e15",
  null
  
)

export default component.exports